import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { BILLING_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { DcrDerApprovalPage } from '@/features/billing/pages/DcrDerApprovalPage';
import { approvalSearchSchema } from '@/features/billing/types/billing.types';

export const Route = createFileRoute('/_auth/billing/approval')({
  beforeLoad: () => requirePermission(BILLING_PERMISSIONS.APPROVAL_VIEW),
  validateSearch: approvalSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="DCR & DER Approval">
      <Suspense fallback={<PageLoader />}>
        <DcrDerApprovalPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
